module.exports = __webpack_public_path__ + "img/42-ABITO-YUKI-U-COLORI-LINO-STAMPE-LINO13.f6fc95ee.jpg";